import qs from 'qs';
import http from './http';
import constant from './constant';

export const sendSmsCodeService = params => http.get(constant.RESET.SEND_SMS_CODE, {params});
export const resetPasswordService = params => http.post(constant.RESET.RESET_PASSWORD, qs.stringify(params), {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
});
